import { Divider, Stack, SxProps } from '@mui/material';
import { MainCategory } from './MainCategory';
import { SubCategory } from './SubCategory';
import { Location } from './Location';
import { useIsDesktop } from 'Hooks';

export interface ICriteriaStyle {
  autoCompleteSx: SxProps;
  autoCompletePaperSx: SxProps;
}

export const CriteriaFilter = () => {
  const isDesktop = useIsDesktop();

  const autoCompleteSx: SxProps = {
    '&&& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&&& .MuiInputBase-root input[dropdown="closed"] ~ fieldset': {
      border: 'none',
    },
    '&&& .MuiOutlinedInput-root': {
      p: 0,
      display: 'flex',
      flexWrap: 'nowrap',
    },
  };

  const autoCompletePaperSx: SxProps = {
    m: '16px 0 0 -10px',
    border: '1px solid #A020FF',
    borderTop: 'none',
    overflow: 'hidden !important',
  };

  return (
    <Stack
      direction='row'
      alignItems='flex'
      flexWrap={isDesktop ? undefined : 'wrap'}
      rowGap={isDesktop ? undefined : '8px'}
      sx={{
        width: 'fit-content',
      }}
    >
      <MainCategory
        autoCompleteSx={autoCompleteSx}
        autoCompletePaperSx={autoCompletePaperSx}
      />
      {isDesktop && (
        <Divider
          orientation='horizontal'
          sx={{
            m: 'auto 16px',
            bgcolor: '#344266',
            width: '1px',
            height: '20px',
          }}
        />
      )}
      <Stack
        direction='row'
        alignItems='center'
        sx={{
          width: 'fit-content',
        }}
      >
        <SubCategory
          autoCompleteSx={autoCompleteSx}
          autoCompletePaperSx={autoCompletePaperSx}
        />
        <Divider
          orientation='horizontal'
          sx={{
            m: '0 16px',
            bgcolor: '#344266',
            width: '1px',
            height: isDesktop ? '20px' : '16px',
          }}
        />
        <Location
          autoCompleteSx={autoCompleteSx}
          autoCompletePaperSx={autoCompletePaperSx}
        />
      </Stack>
    </Stack>
  );
};
